import DailyIframe from '@daily-co/daily-js';
import type { DailyCall } from '@daily-co/daily-js';

/**
 * Singleton manager for Daily.co call instances to prevent duplicate instances
 */
class DailyCallManager {
  private static instance: DailyCall | null = null;
  private static currentUrl: string | null = null;

  /**
   * Get or create a Daily call instance
   */
  static async getCallObject(url: string): Promise<DailyCall> {
    // If we have an existing instance for a different URL, destroy it first
    if (this.instance && this.currentUrl !== url) {
      console.log('Destroying existing Daily instance for different URL');
      try {
        await this.instance.destroy();
        // Small delay to ensure cleanup
        await new Promise(resolve => setTimeout(resolve, 100));
      } catch (e) {
        console.warn('Error destroying existing Daily instance:', e);
      }
      this.instance = null;
      this.currentUrl = null;
    }

    // If we already have an instance for this URL, return it
    if (this.instance && this.currentUrl === url) {
      console.log('Reusing existing Daily instance');
      return this.instance;
    }

    // Create new instance
    console.log('Creating new Daily instance for URL:', url);
    this.instance = DailyIframe.createCallObject({ url });
    this.currentUrl = url;
    return this.instance;
  }

  /**
   * Destroy the current Daily call instance
   */
  static async destroyCallObject(): Promise<void> {
    if (this.instance) {
      console.log('Destroying Daily instance from manager');
      try {
        await this.instance.destroy();
        await new Promise(resolve => setTimeout(resolve, 100));
      } catch (e) {
        console.warn('Error destroying Daily instance:', e);
      }
      this.instance = null;
      this.currentUrl = null;
    }
  }

  /**
   * Get the current instance (if any)
   */
  static getCurrentInstance(): DailyCall | null {
    return this.instance;
  }
}

export default DailyCallManager;
